import Vue from "vue/dist/vue.js";
import '../vendor/jqvmap.min.js';
import { REGIONS, STATES, PROVINCES } from '../constants';
const axios = require('axios');

export let RepresentativeFinder  = Vue.component('representative-finder', {
    props: ['preselect', 'sizes', 'widths', 'representatives'],
    components: { repFilters, repList },
    created() {
        if (this.$props.preselect) {
            this.selected = this.$props.preselect;
        }
    },
    data: function() {
        return {
            selected: '',
            regions: REGIONS,
            states: STATES,
            provinces: PROVINCES,
        }
    },
    computed: {
        selection: function() {
            return this.selected.toLowerCase();
        },
        locales: function() {
            return this.regions.concat(this.states.concat(this.provinces));
        }
    },
    methods: {
        onLocaleSelected: function (locale) {
            this.selected = locale;
            if (history.pushState) {
                var newurl = `${window.location.protocol}//${window.location.host + window.location.pathname}?staff-serving=${locale}`;
                window.history.replaceState({path:newurl},'',newurl);
            }
        },
    },
    template: `
      <div data-block-type="representatives_map" class="content-block">
        <div class="bound">

          <representative-list :provinces="provinces" :selection="selection" :sizes="sizes" :widths="widths"></representative-list>

          <representative-filters :locales="locales" :selection="selection" @localeSelected="onLocaleSelected"></representative-filters>
        </div>
      </div>
    `
});


let repList = Vue.component('representative-list', {
    props: ['selection', 'sizes', 'widths', 'provinces'],
    methods: {
        getReps(locale) {
            var component = this;
            let widths = '';
            if (this.widths) {
                widths = '&widths=' + this.widths;
            }
            axios.get(`/api/representatives.json?staff-serving=${locale.replace(/\s+/g, '-').toLowerCase()}${widths}`)
                .then(function(response) {
                    component.isCanadian = false;
                    for (let i = 0; i < component.provinces.length; i += 1) {
                        if (component.provinces[i][0].toLowerCase() == locale.toLowerCase()) {
                            component.isCanadian = true;
                        }
                    }
                    component.representatives = response.data.data;
                })
                .catch(function (error) {
                    component.representatives = [];
                });
        }
    },
    created() {
        if (this.$props.selection) {
            this.getReps(this.$props.selection);
        }
    },
    data : function() {
        return {
            representatives: [],
            isCanadian: false,
        }
    },
    watch: {
        selection: function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.getReps(newValue);
            }
        }
    },
    template: `
    <div class="rep_results">
      <div v-if="representatives.length === 0" class="empty">Click on the map to find a sales representative.</div>
      <ul class="canada">
        <li v-if="isCanadian" v-for="rep in representatives" class="rep">
          <figure>
            <div class="photo" v-if="rep.photo">
              <div class="content">
                <img :src="rep.image_src || rep.photo" :sizes="sizes" :srcset="rep.srcset" :alt="rep.name" />
              </div>
            </div>
            <figcaption>
              <span class="territory">{{ rep.territory }}</span>
              <span class="name">{{ rep.name }}</span>
              <span class="phone"><a :href="'tel:' + rep.phone">{{ rep.phone }}</a></span>
              <span class="email"><a :href="'mailto:' +  rep.email">{{ rep.email }}</a></span>
            </figcaption>
          </figure>
        </li>        
      </ul>
      <ul class="usa" v-if="!isCanadian">
        <li v-for="rep in representatives" class="rep">
          <figure>
            <div class="photo" v-if="rep.photo">
              <div class="content">
                <img :src="rep.image_src || rep.photo" :sizes="sizes" :srcset="rep.srcset" :alt="rep.name" />
              </div>
            </div>
            <figcaption>
              <span class="territory">{{ rep.territory }}</span>
              <span class="name">{{ rep.name }}</span>
              <span class="phone"><a :href="'tel:' + rep.phone">{{ rep.phone }}</a></span>
              <span class="email"><a :href="'mailto:' +  rep.email">{{ rep.email }}</a></span>
            </figcaption>
          </figure>
        </li>
      </ul>
    </div>
    `
});

let repFilters = Vue.component('representative-filters', {
    props: ['selection', 'locales'],
    components: { repMap },
    methods: {
        onChange: function (locale) {
            this.$emit('localeSelected', locale);
        },
    },
    data: function() {
        return {
        }
    },
    template: `
      <div class="rep_maps">

        <div class="maps-wrapper">
          <representative-map class="content" :locales="locales" :selection="selection" region="canada_en" @onChange="onChange"></representative-map>

          <representative-map class="content" :locales="locales" :selection="selection" region="usa_en" @onChange="onChange"></representative-map>
        </div>

        <div class="mobile_dropdown">
          <div class="fancy_select"><select name="locations" class="form-control input-lg" @change="onChange($event.target.value)">
            <option value="0">Choose a State or Province</option>
            <option v-for="locale in locales"
              :selected="locale[0].toLowerCase() == selection ? 'selected' : ''"
              :value=locale[0]>
              {{ locale[0] }}
            </option>
          </select></div>
          <span class="help-block">Use this dropdown to find local representatives in your area.</span>
        </div>
      </div>
    `,
});

let repMap = Vue.component('representative-map', {
    props: ['selection', 'region', 'locales'],
    data: function() {
        var component = this;
        return {
            settings: {
                map: this.$props.region,
                color: '#C7C7C7',
                hoverColor: '#7A7A7A',
                selectedColor: '#7A7A7A',
                backgroundColor: 'transparent',
                borderWidth: 1,
                borderColor: '#fff',
                borderOpacity: 1,
                enableZoom: false,
                onRegionClick: function(event, code, region) {
                    component.onClicked(region);
                },
                selectedRegions: this.$props.selection
            },
            mapObject: null,
        }
    },
    methods: {
        onClicked: function (stateAbbreviation) {
            this.$emit('onChange', stateAbbreviation);
        },
        convertToAbbreviation: function (locale) {
            for (let i = 0; i < this.locales.length; i += 1) {
                if (this.locales[i][0].toLowerCase() == locale.toLowerCase()) {
                    return (this.locales[i][1]).toLowerCase()
                }
            }
            return locale;
        }
    },
    watch: {
        selection: function(newValue, oldValue) {
            $(this.$el).vectorMap('reset');
            $(this.$el).vectorMap('set', 'selectedRegions', this.convertToAbbreviation(newValue));
        }
    },
    mounted: function() {
        $(this.$el).vectorMap(this.settings);
        this.mapObject = $(this.$el).data('mapObject');
    },
    template: `
        <div></div>
    `,
});
